import { GroupBase, MultiValueProps } from 'react-select';

import { useMultiValueConfiguration } from './hooks';

function MultiValue<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: MultiValueProps<Option, IsMulti, Group>
) {
  const { Component } = useMultiValueConfiguration(props);

  return Component;
}

export default MultiValue;
